<template>
  <div>
    <span
      class="leg-results__results--entry-name" 
      v-html="name"/>
    <span
      v-if="affiliation"
      class="leg-results__results--entry-state"
      v-html="affiliation"/>
  </div>
</template>
<script>
export default {
  name: "LegislatorName",
  props: {
    name: {
      required: true,
      type: String
    },
    affiliation: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
